export const styles = () => ({
  root: {
    color: "#47525E",
    fontSize: 11
  },
});
